// gatsby-browers.js
import { setGclid } from "./src/utils/handleGclid"

export const onRouteUpdate = () => {
  setGclid()
}
